export enum ProfessionalsAnalyticsEnum {
  VIEW_PAGE_PROFESSIONAL_INDEX = '[PAC WEB] Índice de Profissionais - Página visualizada',
  CLICK_PROFESSIONAL_INDEX_FILTER_BY_LETTER = '[PAC WEB] Índice de Profissionais - Clicou em "Filtrar por letra"',
  CLICK_PROFESSIONAL_FOCUS_LETTER = '[PAC WEB] Índice de Profissionais - Expandiu letra',
  CLICK_PROFESSIONAL_INDEX_CLEAR_FILTER = '[PAC WEB] Índice de Profissionais - Clicou em "Limpar filtro"',
  CLICK_PROFESSIONAL_INDEX_VIEW_MORE = '[PAC WEB] Índice de Profissionais - Clicou em "Ver mais"',
  VIEW_PROFESSIONALS_BY_LETTER_PAGE = '[PAC WEB] Índice de Profissionais - Visualizou página de profissionais por letra',

  PROFESSIONAL_PROFILE_VIEW_PAGE = '[PAC WEB] Perfil do Profissional - Página visualizada',

  PROFESSIONAL_PROFILE_CLICK_ABOUT_TAB = '[PAC WEB] Perfil do Profissional - Clicou na aba "Sobre"',
  PROFESSIONAL_PROFILE_CLICK_REVIEWS_TAB = '[PAC WEB] Perfil do Profissional - Clicou na aba "Avaliações"',

  PROFESSIONAL_PROFILE_CLICK_LEARN_MORE = '[PAC WEB] Perfil do Profissional - Clicou em "Saiba mais"',
  PROFESSIONAL_PROFILE_CLICK_AVATAR = '[PAC WEB] Perfil do Profissional - Clicou no avatar',
  PROFESSIONAL_PROFILE_CLICK_SHARE_PROFILE = '[PAC WEB] Perfil do Profissional - Clicou em "Compartilhar perfil"',

  PROFESSIONAL_PROFILE_CLICK_REVIEWS_WITH_COMMENT = '[PAC WEB] Perfil do Profissional - Clicou em "Avaliações com comentário"',
  PROFESSIONAL_PROFILE_CLICK_SHOW_MORE_COMMENTS = '[PAC WEB] Perfil do Profissional - Clicou em "Mostrar mais comentários"',

  PROFESSIONAL_PROFILE_EXPAND_ABOUT_ME = '[PAC WEB] Perfil do Profissional - Expandiu "Sobre mim"',
  PROFESSIONAL_PROFILE_EXPAND_EDUCATION_AND_EXPERIENCE = '[PAC WEB] Perfil do Profissional - Expandiu "Formação & Experiência"',
  PROFESSIONAL_PROFILE_EXPAND_DISEASES = '[PAC WEB] Perfil do Profissional - Expandiu "Doenças"',
  PROFESSIONAL_PROFILE_EXPAND_LANGUAGES = '[PAC WEB] Perfil do Profissional - Expandiu "Idiomas"',
  PROFESSIONAL_PROFILE_EXPAND_COMMENT = '[PAC WEB] Perfil do Profissional - Expandiu comentário',

  PROFESSIONAL_PROFILE_CLICK_IN_PERSON_TAB = '[PAC WEB] Perfil do Profissional - Clicou na aba "Presencial"',
  PROFESSIONAL_PROFILE_CLICK_TELEHEALTH_TAB = '[PAC WEB] Perfil do Profissional - Clicou na aba "Teleconsulta"',
  PROFESSIONAL_PROFILE_EXPAND_PROCEDURE = '[PAC WEB] Perfil do Profissional - Expandiu procedimento',
  PROFESSIONAL_PROFILE_CLICK_SEE_MORE_PROCEDURES = '[PAC WEB] Perfil do Profissional - Clicou em "Ver mais procedimentos"',
  PROFESSIONAL_PROFILE_CLICK_OTHER_SCHEDULES = '[PAC WEB] Perfil do Profissional - Clicou em "Ver outros horários"',

  PROFESSIONAL_PROFILE_SELECT_REDIRECT = '[PAC WEB] Perfil do Profissional - Selecionou redirecionamento (consultas e horários)',

  PROFESSIONAL_PROFILE_REDIRECT_MODAL_SHOWN = '[PAC WEB] Perfil do Profissional - Modal - Exibiu aviso de redirecionamento',
  PROFESSIONAL_PROFILE_REDIRECT_MODAL_CONFIRMED = '[PAC WEB] Perfil do Profissional - Modal - Confirmou redirecionamento',
  PROFESSIONAL_PROFILE_REDIRECT_MODAL_CANCELED = '[PAC WEB] Perfil do Profissional - Modal - Cancelou redirecionamento',
}
